import Hero from './components/Hero';
import StickyContactStrip from './components/StickyContactStrip';
import Difference from './components/Difference';
import PopularServices from './components/PopularServices';
import HowItWorks from './components/HowItWorks';
import ServiceArea from './components/ServiceArea';
import CustomerReviews from './components/CustomerReviews';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <StickyContactStrip />
      <Difference />
      <PopularServices />
      <HowItWorks />
      <ServiceArea />
      <CustomerReviews />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
